import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ArticleSection, StyledButton, CustomInput } from "../components";
import { useScrollToTopAndNavigate } from "../hooks";
import { useTranslation } from "react-i18next";

import bg_05 from "./../images/Content/haeussler-job-01.webp"
import bg_03 from "./../images/Content/46469261_1899766196787909_592792051913850880_n.jpg"
import { sendContactRequest } from "../utils/api/apiNoAuth";
import { validateForm } from "../utils/validation";

const Contact: React.FunctionComponent = () => {
  const { t } = useTranslation(["contact", "common"]);
  const handleNavigation = useScrollToTopAndNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      const validationResult = validateForm([
        { name: "email", value: formData.email, isRequired: true, isEmail: true },
        { name: "phone", value: formData.phone, isRequired: false },
        { name: "name", value: formData.name, isRequired: true },
        { name: "subject", value: formData.subject, isRequired: true },
        { name: "message", value: formData.message, isRequired: true },
      ])

      if (!validationResult.isValid) {
        console.log("Fehler:", validationResult.errors);
        alert("Bitte füllen Sie alle erforderlichen Felder korrekt aus.");
        return;
      }

      await sendContactRequest(formData)
    } catch (error) {
      console.error('Fehler beim Senden:', error);
    }
  }

  const subTitleStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Ultralight",
    fontStyle: "normal",
    fontWeight: 300,
    fontSize: "64px",
    lineHeight: "62px",
    letterSpacing: ".03em",
    textTransform: "capitalize",
    color: "#514633",
    display: "block",
    marginBottom: "65px",
  };

  const contentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontWeight: 300,
    fontSize: "28px",
    lineHeight: "45px",
    color: "#342714",
    letterSpacing: ".05em"
  };

  return (
    <Container>
      <section style={{ marginBottom: "100px" }} id={"section_intro"}>
        <ArticleSection
          layout="article_right_bg"
          title={t("sections.intro.title")}
          content={
            <div>
              <p style={contentStyle}>{t("sections.intro.content")}</p>
            </div>
          }
          imageUrl={bg_03}
          backgroundColor="#DDEBEA"
        />
      </section>
      <section style={{ marginBottom: "100px" }} id={"section_contact"}>
        <Row>
          <Col xl={12} lg={12} md={12} sm={12} xs={12}>
            <div style={subTitleStyle}>{t("form.title")}</div>
          </Col>
        </Row>
        <Row>
          <Col xl={6} lg={6} md={6} sm={12} xs={12}>
            <CustomInput
              name="name"
              label={t("form.fields.name")}
              required
              value={formData.name}
              onChange={handleInputChange}
            />
          </Col>
          <Col xl={6} lg={6} md={6} sm={12} xs={12}>
            <CustomInput
              name="phone"
              label={t("form.fields.phone")}
              value={formData.phone}
              onChange={handleInputChange}
            />
          </Col>
          <Col xl={12} lg={12} md={12} sm={12} xs={12}>
            <CustomInput
              name="email"
              label={t("form.fields.email")}
              required
              value={formData.email}
              onChange={handleInputChange}
            />
          </Col>
          <Col xl={12} lg={12} md={12} sm={12} xs={12}>
            <CustomInput
              name="subject"
              label={t("form.fields.subject")}
              required
              value={formData.subject}
              onChange={handleInputChange}
            />
          </Col>
          <Col xl={12} lg={12} md={12} sm={12} xs={12}>
            <CustomInput
              name="message"
              type="textarea"
              label={t("form.fields.message")}
              required
              value={formData.message}
              onChange={handleInputChange}
            />
          </Col>
          <div style={{ justifyContent: "right", display: "flex" }}>
            <StyledButton title={t("form.button")} onClick={handleSubmit} />
          </div>
        </Row>
      </section>
      <ArticleSection
        layout="article_left"
        title={t("common:sections.jobs.title")}
        content={
          <div>
            <p style={contentStyle}>{t("common:sections.jobs.content")}</p>
            <StyledButton title={t("common:sections.jobs.button")} onClick={() => { handleNavigation("https://bhmm.de/employees#job-offers", { openInNewTab: true }) }} />
          </div>
        }
        imageUrl={bg_05}
        backgroundColor="#DDEBEA"
      />
    </Container>
  );
}

export default Contact;
